import { useCallback, useEffect, useState } from 'react';
import { EmployeeService } from 'services/EmployeeService';

const employeeService = new EmployeeService();

interface Props {
    employee_id: number;
    open: boolean;
}

// Shape flexible del orgpath ya asignado que devuelve /hiring_orgpath.
// Se mantienen alias porque el backend usa `Posicion`, `Range`, `Area[]` y variantes con/sin id numérico.
export interface EmployeeOrgpath {
    hiring_orpath_id?: number | string;
    hiring_id?: number;
    hiring_range_id?: number;
    Hiring?: { hiring_id?: number; name_hiring?: string };
    hiring?: { hiring_id?: number; name_hiring?: string };
    Range?: { start_date?: string; end_date?: string };
    Subcompany?: { id?: number | string; subcompany_id?: number; name?: string; subcompany_name?: string };
    Area?: Array<{ id?: number | string; area_id?: number; name?: string; area_name?: string; lvl?: number; area_level?: number }>;
    Posicion?: { id?: number | string; work_position_id?: number; name?: string; work_position_name?: string };
}

export interface AssignPositionQueryData {
    hiring_range: HiringRange[];
    subcompanies: Subcompany[];
    areas: Area[];
    work_positions: WorkPosition[];
    orgpaths: EmployeeOrgpath[];
}

const EMPTY_DATA: AssignPositionQueryData = {
    hiring_range: [],
    subcompanies: [],
    areas: [],
    work_positions: [],
    orgpaths: [],
};

export const useAssignPositionQuery = ({ employee_id, open }: Props) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<AssignPositionQueryData>(EMPTY_DATA);

    const loadData = useCallback(async () => {
        try {
            setLoading(true);
            const [hiring_range, subcompanies, areas, work_positions, orgpaths] = await Promise.allSettled([
                employeeService.employee.getHiringRange({ employee_id }),
                employeeService.employee.getSubcompany(),
                employeeService.employee.getArea(),
                employeeService.employee.getWorkPosition(),
                employeeService.employee.getHiringOrgpath({ employee_id }),
                // utilizar el endpoint get all area para formar el árbol de areas, y no el endpoint get area que devuelve solo las areas asignadas al empleado
            ]);

            setData({
                hiring_range: hiring_range.status === 'fulfilled' ? hiring_range.value : [],
                subcompanies: subcompanies.status === 'fulfilled' ? subcompanies.value : [],
                areas: areas.status === 'fulfilled' ? areas.value : [],
                work_positions: work_positions.status === 'fulfilled' ? work_positions.value : [],
                orgpaths: orgpaths.status === 'fulfilled' ? ((orgpaths.value as EmployeeOrgpath[]) ?? []) : [],
            });
            console.log('Assign position data loaded:', {
                hiring_range,
                subcompanies,
                areas,
                work_positions,
                orgpaths,
            });
        } catch (error) {
            console.error('Error loading assign position data:', error);
        } finally {
            setLoading(false);
        }
    }, [employee_id]);

    useEffect(() => {
        if (open && employee_id) {
            loadData();
        }
        /* if (!open) {
            setData(EMPTY_DATA);
        } */
    }, [open, employee_id, loadData]);

    return {
        data,
        loading,
        refetch: loadData,
    };
};
